import React, { useState } from 'react';
import WarningModal from '../modals/WarningModal/WarningModal';

let showAlertFunc;

export function showAlert(
  message = '',
  title = '',
  type = 'info',
  showConfirmButton = false,
  cancelText = 'Close',
  confirmText = 'Ok',
  onConfirm,
  onClose,
  showNoButton = false,
  onClickNo
) {
    if (showAlertFunc) showAlertFunc({
      message,
      title,
      type,
      showConfirmButton,
      cancelText,
      confirmText,
      onConfirm,
      onClose,
      showNoButton,
      onClickNo
    });
}

export const WarningModalProvider = ({ children }) => {
  const [modalProps, setModalProps] = useState({ isOpen: false });

  showAlertFunc = (props) => {
    setModalProps({
      ...props,
      isOpen: true,
      onClose: () => {
        setModalProps((prev) => ({ ...prev, isOpen: false }));
        if (props.onClose) props.onClose();
      },
      onConfirm: () => {
        setModalProps((prev) => ({ ...prev, isOpen: false }));
        if (props.onConfirm) props.onConfirm();
      },
      onClickNo: () => {
        setModalProps((prev) => ({ ...prev, isOpen: false }));
        if (props.onClickNo) props.onClickNo();
      }
    });
  };

  return (
    <>
      {children}
      <WarningModal {...modalProps} />
    </>
  );
};
